/* eslint-disable */
import React from 'react'
import { getContext, withContext } from 'recompose'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import StaticPrice from './StaticPrice'

const DiscountDiv = styled.div`
  padding-top: 5px;
`

const currentPrice = (price) => {
  if (typeof price !== 'object') return { current: price }
  if (price.min !== price.max) return { current: `${price.min} - ฿${price.max}` }
  else if (price.min === price.max) return { current: price.min }
  return {
    current: `${price.min} - ฿${price.max}`,
    state: 'range',
  }
}

const Original = getContext(
  {
    price: PropTypes.object,
    discount: PropTypes.object,
  }
)(
  ({ price, discount, ...props }) => (
    <StaticPrice
      className={discount ? 'original-discount' : 'original'}
      price={currentPrice(price).current}
      color={discount ? 'grey' : 'black'}
      hasSymbol
      strikethrough={!!discount}
      {...props}
    />
  )
  )

const Discount = getContext(
  {
    discount: PropTypes.object,
    discountColor: PropTypes.string,
  }
)(
  ({ discount, discountColor, ...props }) => (
    <StaticPrice
      className="discount"
      price={currentPrice(discount).current}
      hasSymbol
      color={discountColor}
      {...props}
    />
  )
  )

const Price = withContext(
  {
    price: PropTypes.object,
    discount: PropTypes.object,
    discountColor: PropTypes.string,
  },
  ({ price, discount, discountColor }) => ({
    price,
    discount,
    discountColor,
  }),
)(
  ({
    className,
    children,
    discount,
    originalSize,
    size,
    discountColor,
  }) => {
    if (React.Children.count(children) > 0) {
      return (
        <div className={className}>
          {children}
        </div>
      )
    }
    return (
      discount ?
        <div className={className}>
          <div>
            <Original size={originalSize} />
          </div>
          <DiscountDiv>
            <Discount size={size} bold color={discountColor} />
          </DiscountDiv>
        </div>
        :
        <div className={className}>
          <Original bold size={size} />
        </div>
    )
  },
)

Price.propTypes = {
  discountColor: PropTypes.string,
  size: PropTypes.string,
  originalSize: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.object, PropTypes.number]).isRequired,
  discount: PropTypes.any,
}

Price.defaultProps = {
  discountColor: 'red',
  size: 'huge',
  originalSize: 'large',
  price: {
    min: 0,
    max: 0,
  },
  discount: null,
  children: null,
}

Price.Original = Original
Price.Discount = Discount

export default Price



// WEBPACK FOOTER //
// ./src/cms/components/productCard/Price.js